import { ReactNode } from 'react';

import { cx } from '@/ui/cva';

export type GridRevealBlockListButtonProps = {
    children: ReactNode;
    onClick: () => void;
};

export function GridRevealBlockListButton({
    children,
    onClick,
}: GridRevealBlockListButtonProps) {
    return (
        <button
            type="button"
            onClick={onClick}
            className={cx(
                'rounded font-bold text-gray underline underline-offset-2 outline-none transition',
                'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue',
                'hover:text-blue',
                'active:scale-95'
            )}
        >
            {children}
        </button>
    );
}
